import type { ReactNode } from 'react';
import { createContext, useContext } from 'react';

import type { ExportSettingsContextType } from '../types/context.types';

const ExportSettingsContext = createContext<ExportSettingsContextType | undefined>(undefined);

export const useExportSettings = () => {
  const context = useContext(ExportSettingsContext);
  if (!context) throw new Error('useExportSettings must be used within ExportProvider.');
  return context;
};

export const ExportSettingsProvider = ({
  children,
  value
}: {
  children: ReactNode;
  value: ExportSettingsContextType;
}) => {
  return <ExportSettingsContext.Provider value={value}>{children}</ExportSettingsContext.Provider>;
};
